import React, { useEffect, useState } from 'react';
// import * as XLSX from 'xlsx';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { updatePageLoadingApi } from '@slice/select.slice';
import AdminLogApi from 'apis/api/AdminLog';
import { IReflect } from '@models/Log';
import { Button, message } from 'antd';
import envStore from '@utils/env';

const ExportExcelButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const timeSelected = useSelector((state: RootState) => state.select.selectedTime);
  // const [data, setData] = useState<Array<IReflect>>([]);

  const options: any[] = [
    { label: 'Báo cáo sự việc/sự cố', value: '1' },
    { label: 'Góp ý cải thiện quy trình/chính sách', value: '2' },
    { label: 'Ý tưởng sáng tạo', value: '3' },
    { label: 'Vấn đề về môi trường làm việc', value: '4' },
    { label: 'Khác (ghi rõ trong nội dung)', value: '5' }
  ];

  const options2: any[] = [
    { label: '1 – Chỉ để tham khảo', value: '1' },
    { label: '2 – Xem xét trong thời gian tới', value: '2' },
    { label: '3 – Mức trung bình, nên xử lý sớm', value: '3' },
    { label: '4 – Nghiêm trọng, cần xử lý gấp', value: '4' },
    { label: '5 – Rất nghiêm trọng, xử lý khẩn cấp', value: '5' }
  ];

  const options3: any[] = [
    // { label: 'Phòng PNC', value: 'PNC', color: COLORS[1] },
    // { label: 'Phòng CSKH', value: 'CSKH', color: COLORS[25] },
    // { label: 'Phòng Kinh doanh', value: 'KD', color: COLORS[2] },
    // { label: 'Phòng Kỹ thuật', value: 'KTH', color: COLORS[5] },
    // { label: 'Phòng Sản xuất', value: 'SX', color: COLORS[23] },
    // { label: 'Phòng Kế toán', value: 'KTO', color: COLORS[35] }
    { label: 'Phòng Nghiên cứu', value: 'PNC' },
    { label: 'Phòng Chăm sóc khách  hàng', value: 'CSKH' },
    { label: 'Phòng Kinh doanh', value: 'KD' },
    { label: 'Phòng Kỹ thuật', value: 'KTH' },
    { label: 'Phòng Sản xuất', value: 'SX' },
    { label: 'Phòng Kế toán', value: 'KTO' },
    { label: 'Chi nhánh Hà Nội', value: 'CNHN' },
    { label: 'Chi nhánh Đà Nẵng', value: 'CNDN' },
    { label: 'Chi nhánh Cần Thơ', value: 'CNCT' },
    { label: 'Không xác định', value: 'OTHER' }
  ];

  const callApi = async () => {
    await AdminLogApi.GetListReflectDetail(timeSelected.beginTime.slice(0, 19), timeSelected.endTime.slice(0, 19)).then(
      res => {
        if (!res.data.error) {
          if (res.data.data.length > 0) {
            handleExport(res.data.data);
            // message.success(t('Administrator.Reflect.GetValueSucces'));
          }
        } else {
          if (res.data.messageCode == 'CODE_EXIST') message.error(t('System.ExistData'));
          else message.error(t('Administrator.Reflect.GetValueFailure'));
        }
        //   setConfirmLoading(false);
      }
    );
  };
  const mapCodesToLabels = (codes: any, options: any[]) => {
    return (
      codes
        ?.split(';')
        .map(v => v.trim())
        .map(code => options.find(opt => opt.value === code)?.label)
        .filter(Boolean)
        .join(', ') || 'Không xác định'
    );
  };

  const handleExport = (data: any[]) => {
    // B1: Chuẩn hóa data

    const exportData = data.map((item, index) => ({
      STT: index + 1,
      Tiêu_đề: item.title,
      // Phòng_ban: item.department,
      // Loại: item.type,
      // Ưu_tiên: item.priority,
      Phòng_ban: mapCodesToLabels(item.department, options3),
      Loại_phản_hồi: mapCodesToLabels(item.type, options),
      Ưu_tiên: mapCodesToLabels(item.priority, options2),
      Nội_dung: item.content.replace(/<[^>]+>/g, ''), // bỏ thẻ HTML
      Hướng_xử_lý: item.resolve,
      File: `${envStore.apiBaseUrl}${item.fileUrl.replace(/\\/g, '/')}`,
      IP: item.ip,
      Thời_gian_tạo: new Date(item.createTime).toLocaleString('vi-VN')
    }));

    // B2: Tạo worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // B3: Thêm header thủ công
    const header = Object.keys(exportData[0]);
    XLSX.utils.sheet_add_aoa(worksheet, [header], { origin: 'A1' });

    // B4: Set width cột
    worksheet['!cols'] = [
      { wch: 5 }, // STT
      { wch: 30 }, // Tiêu đề
      { wch: 30 }, // Phòng ban
      { wch: 30 }, // Loại
      { wch: 30 }, // Mức độ
      { wch: 50 }, // Nội dung
      { wch: 30 }, // Hướng xử lý
      { wch: 50 }, // File
      { wch: 20 }, // IP
      { wch: 25 } // Thời gian
    ];

    // B5: Style header
    header.forEach((_, i) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '228B22' } },
          alignment: { horizontal: 'center', vertical: 'center' },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }
        };
      }
    });

    // B6: Style data rows
    // Style data
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    for (let R = 1; R <= range.e.r; R++) {
      for (let C = 0; C <= range.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (worksheet[cellAddress]) {
          const alignment: any = { horizontal: 'center', vertical: 'center', wrapText: true };

          // Các cột dài: cho phép xuống hàng
          // if (['Tiêu_đề', 'Nội_dung', 'Hướng_xử_lý', 'File'].includes(header[C])) {
          //   alignment = { horizontal: 'center', vertical: 'center', wrapText: true };

          // Nếu muốn xuống dòng theo dấu chấm, thêm logic:
          worksheet[cellAddress].v = String(worksheet[cellAddress].v).replace(/\. /g, '.\n'); // mỗi câu thành 1 dòng
          // }

          worksheet[cellAddress].s = {
            alignment,
            border: {
              top: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
              left: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } }
            }
          };
        }
      }
    }

    // B7: Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DanhSach');

    // B8: Xuất Excel
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `BaoCao_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  return (
    <Button onClick={callApi} type="primary" style={{ background: 'green', border: 'white' }}>
      Xuất Excel
    </Button>
  );
};

export default ExportExcelButton;

